export default {
      id: "link-to-usage",
      viewBox: "0 0 70 26",
      url: "/assets/" + "icons.svg#link-to",
      toString: function () {
        return this.url;
      }
    }